import { Stack } from '@my/ui'
import { HtmlBlock } from './html.block'

export const HtmlComponent = (block: HtmlBlock) => {
  return <Stack dangerouslySetInnerHTML={{ __html: block.html }} />
}
